/* eslint-disable @typescript-eslint/naming-convention */
export enum IconLibrary {
	IcoMoon = 1,
	FlatIcons = 2,
	BizzMine = 3,
	FontAwesome = 4
}